import { Component, ViewChild } from "@angular/core";
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { environment } from "src/environments/environment";
import { H2GlobalSteamReformerService } from "./h2-global-steam-reformer.service";

@Component({
    selector: 'H2ForecastSteamReformer',
    templateUrl: './h2-global-steam-reformer.component.html',
    styleUrls: ['./h2-global-steam-reformer.component.scss']
})

export class H2GlobalSteamReformerComponent {

    dataSource: any[];
    markers: any[] = [];
    map: google.maps.Map;
    infoWindow: google.maps.InfoWindow;
    regionDataSource: any[];
    reportDataSource: any[];
    mapMarkers: any = [];
    colors: any[];
    size: any[];
    isLoadPanelVisible: boolean = false;
    includeAdditionalData: boolean = false;

    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    constructor(private notificationService: NotificationService, h2GlobalSteamReformerService: H2GlobalSteamReformerService) {
        this.isLoadPanelVisible = true;
        h2GlobalSteamReformerService.getReportData().subscribe({
            next: data => {
                this.dataSource = data;
                this.regionDataSource = data.map((item) => item.hycoRegions).filter((value, index, self) => self.indexOf(value) === index);
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching H2 Forecast Report", error);
            }
        });
    }

    exportExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'H2SMRAwardsByRegion.xlsx');
                });
        });
        e.cancel = true;
    }

    getH2ForecastByRegion(data) {
        this.isLoadPanelVisible = true;

        this.reportDataSource = data;
        this.colors = [];
        this.size = [];
        this.markers = [];

        this.markers = [...data].map(item => item);
        this.colors = data.map(item => <any>{ forecastDriverCategoryColor: item.forecastDriverCategoryColor, forecastDriver: item.forecastDriver })
            .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => (a.forecastDriver > b.forecastDriver ? 1 : -1));
        this.size = data.map(item => <any>{ h2Size: item.h2Size, h2SizeRange: item.h2SizeRange }).sort((a, b) => a.h2Size - b.h2Size);
        this.isLoadPanelVisible = false;
    }

    setAdditionalDataFlag(data) {
        this.includeAdditionalData = data;
    }

}